import { apiClient } from './api-client';
import type { UpdateProfileDTO, User } from '@scrambl/shared';

export const usersApi = {
  /**
   * Update the current user's profile
   */
  updateProfile: async (profileData: UpdateProfileDTO): Promise<User> => {
    return apiClient<User>('/users/profile', {
      method: 'PUT',
      body: profileData,
      withAuth: true, // Ensure authentication is included
    });
  },

  /**
   * Update profile by user ID (alternative endpoint)
   */
  updateProfileById: async (userId: string, profileData: UpdateProfileDTO): Promise<User> => {
    return apiClient<User>(`/users/${userId}/profile`, {
      method: 'PUT',
      body: profileData,
      withAuth: true,
    });
  },

  /**
   * Get the current user's profile
   */
  getProfile: async (): Promise<User> => {
    return apiClient<User>('/users/profile');
  },

  /**
   * Update a specific user's profile by ID (admin only)
   */
  updateUserProfile: async (userId: string, profileData: UpdateProfileDTO): Promise<User> => {
    return apiClient<User>(`/users/${userId}/profile`, {
      method: 'PUT',
      body: profileData,
    });
  },
}; 